import { buildService } from './decorated-service';
import { convertDOBToAge } from '../dateUtils';

// 2022-10-04: /prior-year-age and /current-year-age require
// age as of end of current year for accurate contribution limit
// eligibility calculation

// This service takes the age it receives and subtracts 1
const priorYearContribLimits = buildService(
  '/nasu-svc/service/ira-contribution-limits/prior-year-age'
);
// This service takes the age it receives as-is
const currentYearContribLimits = buildService(
  '/nasu-svc/service/ira-contribution-limits/current-year-age'
);

const customerContribLimits = buildService(
  'nasu-svc/service/customer-ira-contribution-limits'
);

export const getPriorYearContribLimits = (
  age: number | undefined
): Promise<any> => {
  return priorYearContribLimits.view(age, { ignoreServiceFailure: true });
};

export const getCurrentYearContribLimits = (
  age: number | undefined
): Promise<any> => {
  return currentYearContribLimits.view(age, { ignoreServiceFailure: true });
};

export const getCustomerContribLimits = (dob): Promise<any[]> => {
  // fallback to contribution limits based on age if
  // existing customer contributions call results in a failure
  const ageAtEndOfCurrentYear = convertDOBToAge(dob);
  const handleCustomerContribLimits = async (): Promise<any> => {
    // This service will adust for prior year age by subtracting 1
    const existingUserPriorYearContribLimitByAge = await getPriorYearContribLimits(
      ageAtEndOfCurrentYear
    );
    const existingUserCurrentYearContribLimitByAge = await getCurrentYearContribLimits(
      ageAtEndOfCurrentYear
    );

    return {
      existingUserPriorYearContribLimitByAge:
        existingUserPriorYearContribLimitByAge[0]?.contributionLimitAmount,
      existingUserCurrentYearContribLimitByAge:
        existingUserCurrentYearContribLimitByAge[0]?.contributionLimitAmount
    };
  };
  return customerContribLimits.http.get('', {
    handleServiceResponse: handleCustomerContribLimits
  });
};
